import { Typography } from "@mui/material";
import React from "react";

export default function Dest({ data }) {
  return (
    <>
      <Typography fontWeight={600} color="text.main" variant="h6">
        {data?.coinSourceName}/<br />
      </Typography>
      <Typography color="text.main" variant="h6">
        {data?.coinDestinationName}
      </Typography>
    </>
  );
}
